import React from "react";
import "./App.css";
import "./styles/main.scss";
import { BodySection } from "./styles/component/style";
import AppRouter from "./AppRoutes";
import Providers from "./providers/Providers";
import Loader from "./components/common/Loader/Loader";
import AlertWrapper from "./components/common/Alert/AlertWrapper";
// import ReactGA from "react-ga";
// import { globalHistory } from "@reach/router";
import SessionLogout from "./components/common/SessionLogout";

// ReactGA.initialize("UA-214190369-1");
function App() {
  return (
    <Providers>
      {/* <Layout image={image} role={role}> */}
      <BodySection>
        <Loader />
        <AlertWrapper />
        <AppRouter />
      </BodySection>
      <SessionLogout />
      {/* </Layout> */}
    </Providers>
  );
}

export default App;
